import axios from "axios";

interface ApiErrorData {
  message?: string;
  errors?: Record<string, string[] | string>;
}

export function getHttpStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

export function isForbiddenError(error: unknown): boolean {
  return getHttpStatus(error) === 403;
}

export function isValidationError(error: unknown): boolean {
  return getHttpStatus(error) === 422;
}

export async function inflateBlobErrorBody(error: unknown): Promise<unknown> {
  if (!axios.isAxiosError(error) || !error.response) return error;

  const data: unknown = error.response.data;
  if (typeof Blob === "undefined" || !(data instanceof Blob)) return error;

  try {
    error.response.data = JSON.parse(await data.text()) as ApiErrorData;
  } catch {}

  return error;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!axios.isAxiosError(error)) return fallback;

  const data = error.response?.data as ApiErrorData | undefined;
  if (!data) return fallback;

  if (data.message) return data.message;

  const firstFieldError = Object.values(data.errors ?? {})[0];
  if (Array.isArray(firstFieldError)) return firstFieldError[0] ?? fallback;
  if (typeof firstFieldError === "string") return firstFieldError;

  return fallback;
}
